export const properties = {
    RESOURCE :'configuraciones',
    URL_GET_NOTICIAS : 'noticias',
    INIT_PAGE : 1,
    RECORDS_PER_PAGE : 5   
}

export const texts  = {
    PAGE_TITLE : 'Noticias'
}
